import {
	DESCRIPTION_MAX_LENGTH,
	NAME_MAX_LENGTH,
} from 'constants/validationConstants'
import * as yup from 'yup'
import { InferType } from 'yup'

import { TTranslationFunction } from '@/types'

export const getRestaurantInfoFormSchema = (t: TTranslationFunction) =>
	yup.object({
		name: yup.string().max(
			NAME_MAX_LENGTH,
			t('ui__field_validation_errors__generic__max_length', {
				length: NAME_MAX_LENGTH,
			}),
		),
		description: yup.string().max(
			DESCRIPTION_MAX_LENGTH,
			t('ui__field_validation_errors__generic__max_length', {
				length: DESCRIPTION_MAX_LENGTH,
			}),
		),
	})

export const getMenuFormSchema = (t: TTranslationFunction) =>
	yup.object({
		sections: yup.array(
			yup.object({
				name: yup
					.string()
					.required(t('ui__field_validation_errors__generic__required'))
					.max(
						NAME_MAX_LENGTH,
						t('ui__field_validation_errors__generic__max_length', {
							length: NAME_MAX_LENGTH,
						}),
					),
				description: yup.string().max(
					DESCRIPTION_MAX_LENGTH,
					t('ui__field_validation_errors__generic__max_length', {
						length: DESCRIPTION_MAX_LENGTH,
					}),
				),
				nameTranslation: yup.string().max(
					NAME_MAX_LENGTH,
					t('ui__field_validation_errors__generic__max_length', {
						length: NAME_MAX_LENGTH,
					}),
				),
				descriptionTranslation: yup.string().max(
					DESCRIPTION_MAX_LENGTH,
					t('ui__field_validation_errors__generic__max_length', {
						length: DESCRIPTION_MAX_LENGTH,
					}),
				),
				visible: yup.boolean(),
				products: yup.array(
					yup.object({
						name: yup
							.string()
							.required(t('ui__field_validation_errors__generic__required'))
							.max(
								NAME_MAX_LENGTH,
								t('ui__field_validation_errors__generic__max_length', {
									length: NAME_MAX_LENGTH,
								}),
							),
						description: yup.string().max(
							DESCRIPTION_MAX_LENGTH,
							t('ui__field_validation_errors__generic__max_length', {
								length: DESCRIPTION_MAX_LENGTH,
							}),
						),
						nameTranslation: yup.string().max(
							NAME_MAX_LENGTH,
							t('ui__field_validation_errors__generic__max_length', {
								length: NAME_MAX_LENGTH,
							}),
						),
						descriptionTranslation: yup.string().max(
							DESCRIPTION_MAX_LENGTH,
							t('ui__field_validation_errors__generic__max_length', {
								length: DESCRIPTION_MAX_LENGTH,
							}),
						),
						price: yup.string().max(
							NAME_MAX_LENGTH,
							t('ui__field_validation_errors__generic__max_length', {
								length: NAME_MAX_LENGTH,
							}),
						),
					}),
				),
			}),
		),
	})

export type TMenuFormFields = InferType<ReturnType<typeof getMenuFormSchema>>

export type TRestaurantInfoFormFields = InferType<
	ReturnType<typeof getRestaurantInfoFormSchema>
>
